import { render, staticRenderFns } from "./WorkflowForm.vue?vue&type=template&id=072af59f"
import script from "./WorkflowForm.vue?vue&type=script&lang=js"
export * from "./WorkflowForm.vue?vue&type=script&lang=js"
import style0 from "./WorkflowForm.vue?vue&type=style&index=0&id=072af59f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports